/** Theme presets for SCHOOLIN AI.
 *  Each theme is a set of CSS variable values (HSL components, space-separated).
 *  Applied at runtime by ThemeProvider via document.documentElement.style.setProperty.
 */
export const THEMES = {
  emerald: {
    label: "Emerald",
    label_ar: "زمردي",
    isDark: false,
    vars: {
      "--background": "60 12% 97%",
      "--foreground": "222 47% 11%",
      "--card": "0 0% 100%",
      "--card-foreground": "222 47% 11%",
      "--popover": "0 0% 100%",
      "--popover-foreground": "222 47% 11%",
      "--primary": "150 81% 20%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "35 41% 50%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "60 8% 94%",
      "--muted-foreground": "215 16% 40%",
      "--accent": "17 64% 37%",
      "--accent-foreground": "0 0% 100%",
      "--destructive": "0 72% 45%",
      "--destructive-foreground": "0 0% 100%",
      "--border": "60 10% 87%",
      "--input": "60 10% 87%",
      "--ring": "150 81% 20%",
      "--chart-1": "150 81% 26%",
      "--chart-2": "35 41% 50%",
      "--chart-3": "17 64% 37%",
      "--chart-4": "200 70% 38%",
      "--chart-5": "280 50% 45%",
    },
  },
  royal: {
    label: "Royal Blue",
    label_ar: "أزرق ملكي",
    isDark: false,
    vars: {
      "--background": "210 30% 98%",
      "--foreground": "222 47% 11%",
      "--card": "0 0% 100%",
      "--card-foreground": "222 47% 11%",
      "--popover": "0 0% 100%",
      "--popover-foreground": "222 47% 11%",
      "--primary": "220 80% 32%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "45 90% 50%",
      "--secondary-foreground": "30 50% 10%",
      "--muted": "210 20% 94%",
      "--muted-foreground": "215 16% 40%",
      "--accent": "350 75% 50%",
      "--accent-foreground": "0 0% 100%",
      "--destructive": "0 72% 45%",
      "--destructive-foreground": "0 0% 100%",
      "--border": "210 18% 87%",
      "--input": "210 18% 87%",
      "--ring": "220 80% 32%",
      "--chart-1": "220 80% 40%",
      "--chart-2": "45 90% 50%",
      "--chart-3": "350 75% 50%",
      "--chart-4": "170 60% 40%",
      "--chart-5": "280 60% 50%",
    },
  },
  sunset: {
    label: "Sunset",
    label_ar: "غروب",
    isDark: false,
    vars: {
      "--background": "30 30% 98%",
      "--foreground": "20 40% 12%",
      "--card": "0 0% 100%",
      "--card-foreground": "20 40% 12%",
      "--popover": "0 0% 100%",
      "--popover-foreground": "20 40% 12%",
      "--primary": "15 80% 45%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "40 90% 55%",
      "--secondary-foreground": "30 50% 10%",
      "--muted": "30 20% 94%",
      "--muted-foreground": "20 16% 40%",
      "--accent": "340 70% 45%",
      "--accent-foreground": "0 0% 100%",
      "--destructive": "0 72% 45%",
      "--destructive-foreground": "0 0% 100%",
      "--border": "30 18% 87%",
      "--input": "30 18% 87%",
      "--ring": "15 80% 45%",
      "--chart-1": "15 80% 50%",
      "--chart-2": "40 90% 55%",
      "--chart-3": "340 70% 45%",
      "--chart-4": "175 60% 40%",
      "--chart-5": "260 50% 55%",
    },
  },
  midnight: {
    label: "Midnight",
    label_ar: "ليلي",
    isDark: true,
    vars: {
      "--background": "222 25% 8%",
      "--foreground": "210 40% 96%",
      "--card": "222 22% 12%",
      "--card-foreground": "210 40% 96%",
      "--popover": "222 22% 12%",
      "--popover-foreground": "210 40% 96%",
      "--primary": "160 70% 45%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "40 90% 60%",
      "--secondary-foreground": "20 40% 10%",
      "--muted": "222 18% 16%",
      "--muted-foreground": "215 20% 70%",
      "--accent": "260 70% 65%",
      "--accent-foreground": "0 0% 100%",
      "--destructive": "0 62% 50%",
      "--destructive-foreground": "0 0% 98%",
      "--border": "222 14% 22%",
      "--input": "222 14% 22%",
      "--ring": "160 70% 45%",
      "--chart-1": "160 70% 50%",
      "--chart-2": "40 90% 60%",
      "--chart-3": "260 70% 65%",
      "--chart-4": "200 70% 55%",
      "--chart-5": "340 70% 60%",
    },
  },
  plum: {
    label: "Plum",
    label_ar: "برقوقي",
    isDark: false,
    vars: {
      "--background": "300 20% 98%",
      "--foreground": "290 30% 12%",
      "--card": "0 0% 100%",
      "--card-foreground": "290 30% 12%",
      "--popover": "0 0% 100%",
      "--popover-foreground": "290 30% 12%",
      "--primary": "290 50% 35%",
      "--primary-foreground": "0 0% 100%",
      "--secondary": "170 50% 40%",
      "--secondary-foreground": "0 0% 100%",
      "--muted": "300 18% 94%",
      "--muted-foreground": "290 16% 40%",
      "--accent": "30 70% 50%",
      "--accent-foreground": "0 0% 100%",
      "--destructive": "0 72% 45%",
      "--destructive-foreground": "0 0% 100%",
      "--border": "300 18% 87%",
      "--input": "300 18% 87%",
      "--ring": "290 50% 35%",
      "--chart-1": "290 50% 40%",
      "--chart-2": "170 50% 40%",
      "--chart-3": "30 70% 50%",
      "--chart-4": "220 60% 45%",
      "--chart-5": "350 60% 50%",
    },
  },
};

export const THEME_KEYS = Object.keys(THEMES);
